import { QRLoginAccessDetails } from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

type Variables = QRLoginAccessDetails

export function useScanWebQR() {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationKey: keys.qr,
    mutationFn: scanWebQR,
    onSuccess: async () => {
      client.invalidateQueries({ queryKey: keys.qr }).catch(() => null)
    },
  })

  async function scanWebQR({ deviceToken }: Variables) {
    await server.post(
      `/v2/scan_qr?device_token=${deviceToken}`,
      {},
      'user',
      'urlEncoded'
    )
  }
}
